<div data-qa-id="errors-container" class="errors-container">
  <div data-qa-id="errors-list-forcedErrors" v-if="errorsToRender.forcedErrors.length > 0" class="errors-list">
    <MdTypography data-qa-id="errors-list-forcedErrors-details" tag="p"
      v-for="(error, key) in errorsToRender.forcedErrors" :key="key" variant="body2--regular" :color="error.type === errorTypes.warning ? 'orange-squash--500' : 'red-babe--500'">
      {{ error.message }}
    </MdTypography>
  </div>
  <div data-qa-id="errors-list-validationErrors" v-if="errorsToRender.validationErrors.length > 0" class="errors-list">
    <MdTypography data-qa-id="errors-list-validationErrors-details" tag="p"
      v-for="(error, key) in errorsToRender.validationErrors" :key="key" variant="body2--regular"
      :color="error.type === errorTypes.warning ? 'orange-squash--500' : 'red-babe--500'">
      {{ error.message }}
    </MdTypography>
  </div>
  <div data-qa-id="errors-list-aiSuggestedErrors" v-if="errorsToRender.aiSuggestedErrors.length >0" class="errors-list">
    <MdTypography data-qa-id="errors-list-aiSuggestedErrors-details" tag="p"
      v-for="(error, key) in errorsToRender.aiSuggestedErrors" :key="key" variant="body2--regular"
      color="red-babe--500">
      {{ error.message }}
    </MdTypography>
  </div>
</div>